import { FallbackImage } from "../../../../generic components/ImageWithfallback/ImageWithfallback";
import ClampText from "../../../../generic components/TextTruncate/TextTruncate";
import classes from "./userCard.module.scss";
import { Descriptions, Rate, Tag } from "antd";

const UserCard = (props) => {
  return (
    props.user && (
      <div key={props.key} className={classes.container}>
        {"image" in props.user && (
          <div className={classes.image_container}>
            <FallbackImage
              src={props.user.image}
              width={"100%"}
              preview={false}
            />
          </div>
        )}
        <div className={classes.info}>
          <h3>
            {
              <ClampText
                text={props.user.name ?? props.user.title ?? props.user.text}
              />
            }
          </h3>
          {"rating" in props.user && (
            <Rate disabled defaultValue={props.user.rating} />
          )}
          {props.user.publishDate && (
            <p className={classes.small_text}>
              <span style={{ fontWeight: "700" }}>Published: </span>
              {new Date(props.user.publishDate).toLocaleDateString()}
            </p>
          )}
          <div className={classes.tags}>
            {"isPublished" in props.user && (
              <>
                <Descriptions.Item label="Verified">
                  {props.user.isPublished ? (
                    <Tag color="green">Published</Tag>
                  ) : (
                    <Tag color="red">Not Published</Tag>
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Verified">
                  {props.user.isHomepage ? (
                    <Tag color="green">In Homepage</Tag>
                  ) : (
                    <Tag color="red">Not in Homepage</Tag>
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Verified">
                  {props.user.isFeatured ? (
                    <Tag color="green">Featured</Tag>
                  ) : (
                    <Tag color="red">Not Featured</Tag>
                  )}
                </Descriptions.Item>
              </>
            )}

            {"isRecurrent" in props.user && (
              <>
                <Descriptions.Item label="Verified">
                  {props.user.isRecurrent ? (
                    <Tag color="green">Recurrent</Tag>
                  ) : (
                    <Tag color="red">Not Recurrent</Tag>
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Verified">
                  {props.user.isAvailable ? (
                    <Tag color="green">Available</Tag>
                  ) : (
                    <Tag color="red">Not Available</Tag>
                  )}
                </Descriptions.Item>
                {props.user.isHot && (
                  <Descriptions.Item label="Verified">
                    <Tag color="red">Hot</Tag>
                  </Descriptions.Item>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default UserCard;
